'use client'

import { usePathname } from 'next/navigation'
import Footer from './footer'

const LayoutFooter = () => {
  const pathname = usePathname()
  const fullscreenPages = ['/models/leaderboard', '/voice-models/leaderboard']
  const isFullscreen = fullscreenPages.includes(pathname)

  if (isFullscreen) return null
  return <Footer />
}

export default LayoutFooter
